var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-6 px-4 py-5 text-center"},[_c('h1',{staticClass:"text-3xl sm:text-4xl font-extralight"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }